import type { ReactNode } from "react";

import { Stack } from "@mui/material";
import { FormRowLabel } from "components/FormRowLabel";
import { Icon, type IconName } from "components/Icon";
import { cn } from "utils/styling";

type EnergyAnalysisSettingsGroupProps = {
  children: ReactNode;
  className?: string;
  iconName?: IconName;
  label?: string | undefined;
};

export const EnergyAnalysisSettingsGroup = ({ children, className, iconName, label }: EnergyAnalysisSettingsGroupProps) => (
  <Stack className={cn("flex-col items-start gap-1", className)}>
    <Stack className="items-center gap-1" direction="row">
      {iconName ? <Icon iconName={iconName} size="sm" /> : null}
      <FormRowLabel className="text-lds-foreground-muted font-ds-body-regular-sm" label={label} />
    </Stack>
    {children}
  </Stack>
);
